import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import API from "../../api/api";

export default function MedalTally() {
  const navigate = useNavigate();
  const { event_id } = useParams();
  const [searchParams] = useSearchParams();
  const gender = (searchParams.get("gender") || "all").toLowerCase();
  const date = searchParams.get("date") || "";
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const gameDayContextQuery = useMemo(() => {
    const q = new URLSearchParams();
    if (date) q.set("date", date);
    if (event_id) q.set("event_id", String(event_id));
    q.set("gender", gender || "all");
    return q.toString();
  }, [date, event_id, gender]);

  useEffect(() => {
    const fetchTally = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await API.get(`/admin/medal-tally/${event_id}`);
        setRows(Array.isArray(res) ? res : []);
      } catch (err) {
        setError(err?.message || "Failed to load medal tally");
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    if (event_id) fetchTally();
  }, [event_id]);

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-5xl mx-auto p-6">
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-3xl font-bold text-gray-900">Medal Tally</h1>
            <button
              onClick={() => navigate(`/admin/game-day?${gameDayContextQuery}`)}
              className="text-sm px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
            >
              Back to Game Day
            </button>
          </div>

          <div className="bg-white rounded-xl shadow p-5">
            {loading ? <p>Loading...</p> : null}
            {!loading && error ? <p className="text-red-600">{error}</p> : null}
            {!loading && !error && !rows.length ? (
              <p className="text-gray-600">No medal data found for this event.</p>
            ) : null}

            {!loading && !error && rows.length ? (
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-200">
                  <thead>
                    <tr className="bg-gray-100 text-left">
                      <th className="p-3 border-b">District</th>
                      <th className="p-3 border-b">Gold</th>
                      <th className="p-3 border-b">Silver</th>
                      <th className="p-3 border-b">Bronze</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, i) => (
                      <tr key={i} className="border-b">
                        <td className="p-3">{row.district}</td>
                        <td className="p-3 font-semibold text-yellow-700">{row.gold}</td>
                        <td className="p-3 font-semibold text-gray-600">{row.silver}</td>
                        <td className="p-3 font-semibold text-orange-700">{row.bronze}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
